/** @typedef {import('../types/anomalyTimeSeries.types').TimeSeriesDataPoint} TimeSeriesDataPoint */

import { SEVERITY_RANK } from "./timelineHealth";

const avg = (nums) => {
  const valid = nums.filter((n) => n != null && !Number.isNaN(n));
  if (!valid.length) return null;
  return valid.reduce((a, b) => a + b, 0) / valid.length;
};

/**
 * @param {TimeSeriesDataPoint[]} dataPoints
 */
export const computeHealthyUnhealthyComparison = (dataPoints) => {
  const healthy = dataPoints.filter((dp) => !dp.hasAnomaly);
  const unhealthy = dataPoints.filter((dp) => dp.hasAnomaly);

  let longestClean = 0;
  let current = 0;
  dataPoints.forEach((dp) => {
    if (!dp.hasAnomaly) {
      current += 1;
      longestClean = Math.max(longestClean, current);
    } else {
      current = 0;
    }
  });

  let maxDeviation = null;
  let maxDeviationPeriod = null;
  let maxAnomalyCount = 0;
  let maxAnomalyCountPeriod = null;
  let mostSeverePeriod = null;
  let mostSevereRank = 0;

  unhealthy.forEach((dp) => {
    const dev = Math.abs(dp.maxDeviationPct || 0);
    if (maxDeviation == null || dev > maxDeviation) {
      maxDeviation = dev;
      maxDeviationPeriod = dp.period;
    }
    if (dp.anomalyCount > maxAnomalyCount) {
      maxAnomalyCount = dp.anomalyCount;
      maxAnomalyCountPeriod = dp.period;
    }
    const rank = SEVERITY_RANK[dp.maxSeverity] || 0;
    if (rank > mostSevereRank) {
      mostSevereRank = rank;
      mostSeverePeriod = dp.period;
    }
  });

  return {
    healthy: {
      count: healthy.length,
      averageValue: avg(healthy.map((dp) => dp.value)),
      longestCleanStreak: longestClean,
    },
    unhealthy: {
      count: unhealthy.length,
      averageValue: avg(unhealthy.map((dp) => dp.value)),
      highestDeviation: maxDeviation,
      highestDeviationPeriod: maxDeviationPeriod,
      maxAnomalyCount,
      maxAnomalyCountPeriod,
      mostSeverePeriod,
    },
  };
};
